/* global axios */

import ApiClient from './ApiClient';

class Global extends ApiClient {
  constructor() {
    super('', { accountScoped: false });
  }

  getAllInboxs() {
    return axios.get(`${this.url}/all_inboxes`);
  }

  sendWithdrawMessage(params) {
    return axios.post(`${this.url}/ocr/withdraw_button`, params);
  }
}

export default new Global();
